/** Result-list cap — fuzzySearch already limits, this keeps the DOM small too. */
export const MAX_RESULTS = 25;

/** localStorage keys for the persisted recent / favorite lists (most-recent first). */
export const RECENT_KEY = 'clean-jsdoc-theme:recent-searches';
export const FAVORITE_KEY = 'clean-jsdoc-theme:favorite-searches';

/** Per-list caps. */
export const MAX_RECENT = 7;
export const MAX_FAVORITES = 10;
